import { Link } from "@ui/Atoms/Link/Link";
export type SiteFooterLink = { label: string; href: string };

type Props = {
	/** e.g. "(c) 2026 ConnectingFlavors". */
	copyright: string;
	links?: SiteFooterLink[];
};

export function SiteFooter({ copyright, links = [] }: Props) {
	return (
		<footer className="border-t border-[var(--border-subtle)] bg-[var(--surface-muted)] px-6 py-6">
			<div className="mx-auto flex max-w-[1360px] flex-col items-center gap-2 text-[12.5px] text-[var(--content-faint)] sm:flex-row sm:justify-between">
				<span>{copyright}</span>
				{links.length > 0 && (
					<nav className="flex gap-4">
						{links.map((link) => (
							<Link
								key={link.href}
								href={link.href}
								className="text-[var(--content-faint)] hover:text-[var(--content-muted)]"
							>
								{link.label}
							</Link>
						))}
					</nav>
				)}
			</div>
		</footer>
	);
}
